export const MAX_CHAR_LENGTH = {
  tokenSymbol: 8,
  description: 280,
  behindTheMusic: 6000,
  manuallyAddedDescription: 144,
  rewardTitle: 60,
  rewardDescription: 300,
  lyrics: 6000,
} as const;
